"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lurker = _interopRequireDefault(require("./lurker"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var logSuccess = function logSuccess() {
  return _lurker["default"].quarentenaApiCall('success');
};
var logFailure = function logFailure(error) {
  return _lurker["default"].quarentenaApiCall('error', {
    exception: error
  });
};
var fetcherPost = function fetcherPost() {
  return fetch('https://usc-api.olx.com.br/chat', {
    'headers': {
      'x-api-key': 'f64705c5-fec0-4cbf-9936-0173471819a2'
    },
    'referrerPolicy': 'strict-origin-when-cross-origin',
    'method': 'POST',
    'mode': 'cors',
    'credentials': 'include'
  }).then(function (response) {
    return response.json();
  }).then(function (response) {
    if (response) {
      logSuccess();
      return response;
    } else {
      logFailure('empty response');
    }
  })["catch"](function (response) {
    logFailure("".concat(response));
  });
};
var _default = exports["default"] = fetcherPost;